module.exports = __webpack_public_path__ + "03dffdece2493fa1ea1c1ce0553d9088.png";